import { render } from "./DoubleOptin.vue?vue&type=template&id=4c41519d&scoped=true"
import script from "./DoubleOptin.vue?vue&type=script&lang=js"
export * from "./DoubleOptin.vue?vue&type=script&lang=js"

import "./DoubleOptin.vue?vue&type=style&index=0&id=4c41519d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c41519d"]])

export default __exports__